const RE_ADBLOCK = /(ди|myt)(рект|arget)/gmi;

export default function (name) {
	if (name && typeof name === 'string') {
		return name.replace(RE_ADBLOCK, '$1' + '\u2060' + '$2');
	}

	return name;
}
